import React, { useRef, useEffect } from 'react'
import { Tooltip as ReactTooltip } from 'react-tooltip'
import OutsideClickHandler from 'react-outside-click-handler'
import useIsMobile from '../../hooks/IsMobile'
import ITooltip from './Tooltip.interface'
// import styles from './Tooltip.module.scss'

const Tooltip: React.FC<ITooltip> = ({
  effect = 'solid',
  place = 'top',
  type = 'light',
  text,
  className,
  children,
}) => {
  const divRef = useRef<HTMLDivElement>(null)
  const tooltipId = useRef(`tooltip-${Math.random().toString(36).substring(2, 9)}`).current

  const isMobile = useIsMobile()
  const event = isMobile ? 'click' : 'mouseenter'

  const handleShow = () => {
    if (event.includes('click') && divRef?.current) {
      // In v5, we don't need to manually show tooltips
    }
  }

  const handleHide = () => {
    if (event.includes('mouseenter') && divRef?.current) {
      // In v5, we don't need to manually hide tooltips
    }
  }

  return (
    <OutsideClickHandler
      onOutsideClick={() => {
        if (event.includes('click') && divRef?.current) {
          // No need to manually hide in v5
        }
      }}
    >
      <div
        ref={divRef}
        data-tooltip-id={tooltipId}
        data-tooltip-content={text}
        className={className}
        onClick={() => {
          if (event.includes('click') && divRef?.current) {
            handleShow()
          }
        }}
        onMouseEnter={() => {
          if (event.includes('click') && divRef?.current) {
            handleShow()
          }
        }}
        onMouseLeave={() => {
          if (event.includes('mouseenter') && divRef?.current) {
            handleHide()
          }
        }}
      >
        {children}
      </div>
      <ReactTooltip
        id={tooltipId}
        place={place}
        variant={type === 'dark' ? 'dark' : 'light'}
        style={{
          backgroundColor: type === 'dark' ? '#1B1D1E' : '#fff',
          color: type === 'dark' ? '#fff' : '#000',
        }}
        delayShow={100}
        delayHide={100}
      />
    </OutsideClickHandler>
  )
}
export default Tooltip
